import { render, staticRenderFns } from "./EntityView.vue?vue&type=template&id=6c51ba56&scoped=true"
import script from "./EntityView.vue?vue&type=script&lang=js"
export * from "./EntityView.vue?vue&type=script&lang=js"
import style0 from "./EntityView.vue?vue&type=style&index=0&id=6c51ba56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c51ba56",
  null
  
)

export default component.exports